/* Contact page (sections/ct-contact.liquid): reveal on scroll, copy buttons (e-mail, number), inline form validation and
   focus on the success / error message after the form was sent. Everything works without JS (native validation, links). */
(function () {
  var sec = document.getElementById('ct');
  if (!sec || sec.__ct) return;
  sec.__ct = true;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* reveal on scroll */
  if (!reduce && 'IntersectionObserver' in window) {
    sec.classList.add('ct--anim');
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target; el.classList.add('is-in'); io.unobserve(el);
        setTimeout(function () { el.removeAttribute('data-ct-r'); el.classList.remove('is-in'); }, 1300);
      });
    }, { rootMargin: '0px 0px -6% 0px' });
    sec.querySelectorAll('[data-ct-r]').forEach(function (el) { io.observe(el); });
  }

  /* copy buttons */
  function fallbackCopy(text) {
    var ta = document.createElement('textarea');
    ta.value = text; ta.setAttribute('readonly', ''); ta.style.position = 'fixed'; ta.style.opacity = '0';
    document.body.appendChild(ta); ta.select();
    var ok = false; try { ok = document.execCommand('copy'); } catch (e) {}
    ta.remove(); return ok;
  }
  sec.addEventListener('click', function (ev) {
    var b = ev.target.closest('[data-ct-copy]');
    if (!b) return;
    var text = b.getAttribute('data-ct-copy');
    var label = b.querySelector('[data-ct-copy-label]');
    var done = function () {
      if (!label) return;
      if (!b.__orig) b.__orig = label.textContent;
      label.textContent = sec.getAttribute('data-copied') || b.__orig;
      b.classList.add('is-done');
      clearTimeout(b.__t);
      b.__t = setTimeout(function () { label.textContent = b.__orig; b.classList.remove('is-done'); }, 1800);
    };
    if (navigator.clipboard && window.isSecureContext) navigator.clipboard.writeText(text).then(done, function () { if (fallbackCopy(text)) done(); });
    else if (fallbackCopy(text)) done();
  });

  /* form: inline errors instead of the browser bubbles */
  var form = document.getElementById('ct-form');
  var msgs = sec.querySelector('[data-ct-msgs]');
  if (form && msgs) {
    form.noValidate = true;
    var alertBox = form.querySelector('[data-ct-alert]');
    var fields = [].slice.call(form.querySelectorAll('input[required], select[required], textarea[required]'));
    var message = function (el) {
      if (el.type === 'checkbox') return msgs.getAttribute('data-consent');
      if (el.tagName === 'SELECT') return msgs.getAttribute('data-topic');
      if (el.type === 'email' && el.value.trim()) return msgs.getAttribute('data-email');
      return msgs.getAttribute('data-required');
    };
    var check = function (el) {
      var wrap = el.closest('.ct-field');
      if (el.type !== 'checkbox' && el.tagName !== 'SELECT') el.value = el.value.replace(/^\s+$/, '');
      var ok = el.checkValidity();
      if (el.type === 'email' && ok && el.value && !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(el.value.trim())) ok = false;
      if (wrap) {
        wrap.classList.toggle('is-err', !ok);
        var err = wrap.querySelector('[data-ct-err]');
        if (err) err.textContent = ok ? '' : message(el);
      }
      if (ok) el.removeAttribute('aria-invalid'); else el.setAttribute('aria-invalid', 'true');
      return ok;
    };
    form.addEventListener('submit', function (ev) {
      var first = null;
      fields.forEach(function (el) { if (!check(el) && !first) first = el; });
      if (first) {
        ev.preventDefault();
        if (alertBox && !alertBox.querySelector('ul')) alertBox.hidden = false;
        first.focus({ preventScroll: true });
        first.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
        return;
      }
      if (alertBox && !alertBox.querySelector('ul')) alertBox.hidden = true;
      var btn = form.querySelector('button[type="submit"]');
      if (btn) { btn.setAttribute('aria-busy', 'true'); btn.style.opacity = '.7'; setTimeout(function () { btn.removeAttribute('aria-busy'); btn.style.opacity = ''; }, 8000); }
    });
    fields.forEach(function (el) {
      var ev = el.type === 'checkbox' || el.tagName === 'SELECT' ? 'change' : 'blur';
      el.addEventListener(ev, function () { if (el.closest('.ct-field.is-err') || (ev === 'blur' && el.value)) check(el); });
      el.addEventListener('input', function () { if (el.closest('.ct-field.is-err')) check(el); });
      el.addEventListener(ev, function () { if (alertBox && !alertBox.querySelector('ul') && !form.querySelector('.ct-field.is-err')) alertBox.hidden = true; });
    });
  }

  /* after sending: bring the success / error message into view */
  var target = sec.querySelector('[data-ct-ok]') || sec.querySelector('[data-ct-alert]:not([hidden])');
  if (target) {
    var card = target.closest('.ct-formcard') || target;
    setTimeout(function () {
      card.scrollIntoView({ behavior: 'auto', block: 'center' });
      target.focus({ preventScroll: true });
    }, 120);
  }
})();
